import ChatActionPanel from './ChatActionPanel'

const PhotoRetryAction = ({
  visible,
  disabled,
  onRetry,
}) => {
  if (!visible) return null

  return (
    <ChatActionPanel>
      <button
        type='button'
        className='upload-send-btn'
        onClick={onRetry}
        disabled={disabled}
        style={{ minWidth: '180px' }}
      >
        Retry photo
      </button>
    </ChatActionPanel>
  )
}

export default PhotoRetryAction